const MARKDOWN_EXTENSION_REGEX = /\.mdx?$/;
const NEXTRA_INTERNAL = Symbol.for("__nextra_internal__");
const ERROR_ROUTES = /* @__PURE__ */ new Set(["/404", "/500"]);
const DEFAULT_LOCALE = "en-US";
export {
  DEFAULT_LOCALE,
  ERROR_ROUTES,
  MARKDOWN_EXTENSION_REGEX,
  NEXTRA_INTERNAL
};
